<template>
    <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
        <div class="formatbar">
            <button
                tabindex="-1"
                class="formatbar__button"
                @click="commands.undo"
            >
                <icon name="undo" />
            </button>

            <button
                tabindex="-1"
                class="formatbar__button"
                @click="commands.redo"
            >
                <icon name="redo" />
            </button>

            <!-- <FormulateInput
                :value="color"
                type="color"
                name="sample"
                @input="test($event, commands)"
            /> -->
            <!-- <input type="color" v-model="color" name="color" /> -->
            <v-swatches
                v-model="color"
                :swatches="swatches"
                :show-labels="false"
                shapes="circles"
                row-length="5"
                swatch-size="25"
                @input="val => setColour(val, commands)"
            />

            <button
                tabindex="-1"
                class="formatbar__button"
                :class="{ 'formatbar__button--active': isActive.bold() }"
                @click="commands.bold"
            >
                <icon name="bold" />
            </button>

            <button
                tabindex="-1"
                class="formatbar__button"
                :class="{ 'formatbar__button--active': isActive.italic() }"
                @click="commands.italic"
            >
                <icon name="italic" />
            </button>

            <button
                tabindex="-1"
                class="formatbar__button"
                :class="{ 'formatbar__button--active': isActive.strike() }"
                @click="commands.strike"
            >
                <icon name="strike" />
            </button>

            <button
                tabindex="-1"
                class="formatbar__button"
                :class="{ 'formatbar__button--active': isActive.underline() }"
                @click="commands.underline"
            >
                <icon name="underline" />
            </button>
<!--
            <button
                tabindex="-1"
                class="formatbar__button"
                :class="{ 'formatbar__button--active': isActive.code() }"
                @click="commands.code"
            >
            <icon name="code" />
            </button> -->

            <button
                tabindex="-1"
                class="formatbar__button"
                :class="{ 'formatbar__button--active': isActive.paragraph() }"
                @click="commands.paragraph"
            >
            <icon name="paragraph" />
            </button>

            <button
                tabindex="-1"
                class="formatbar__button"
                :class="{ 'formatbar__button--active': isActive.heading({ level: 1 }) }"
                @click="commands.heading({ level: 1 })"
            >
            H1
            </button>

            <button
                tabindex="-1"
                class="formatbar__button"
                :class="{ 'formatbar__button--active': isActive.heading({ level: 2 }) }"
                @click="commands.heading({ level: 2 })"
            >
            H2
            </button>

            <button
                tabindex="-1"
                class="formatbar__button"
                :class="{ 'formatbar__button--active': isActive.heading({ level: 3 }) }"
                @click="commands.heading({ level: 3 })"
            >
            H3
            </button>

            <button
                tabindex="-1"
                class="formatbar__button"
                :class="{ 'formatbar__button--active': isActive.heading({ level: 4 }) }"
                @click="commands.heading({ level: 4 })"
            >
            H4
            </button>

            <button
                tabindex="-1"
                class="formatbar__button"
                :class="{ 'formatbar__button--active': isActive.heading({ level: 5 }) }"
                @click="commands.heading({ level: 5 })"
            >
            H5
            </button>

            <!-- <button
                tabindex="-1"
                class="formatbar__button"
                :class="{ 'formatbar__button--active': isActive.heading({ level: 6 }) }"
                @click="commands.heading({ level: 6 })"
            >
            H6
            </button> -->

            <button
                tabindex="-1"
                class="formatbar__button"
                :class="{ 'formatbar__button--active': isActive.bullet_list() }"
                @click="commands.bullet_list"
            >
                <icon name="ul" />
            </button>

            <button
                tabindex="-1"
                class="formatbar__button"
                :class="{ 'formatbar__button--active': isActive.ordered_list() }"
                @click="commands.ordered_list"
            >
                <icon name="ol" />
            </button>

            <button
                tabindex="-1"
                class="formatbar__button"
                :class="{ 'formatbar__button--active': isActive.blockquote() }"
                @click="commands.blockquote"
            >
                <icon name="quote" />
            </button>

            <!-- <button
                tabindex="-1"
                class="formatbar__button"
                :class="{ 'formatbar__button--active': isActive.code_block() }"
                @click="commands.code_block"
            >
                <icon name="code" />
            </button> -->

            <button
                tabindex="-1"
                class="formatbar__button"
                @click="commands.createTable({rowsCount: 3, colsCount: 3, withHeaderRow: false })"
            >
                <icon name="table" />
            </button>

                <button
                    tabindex="-1"
                    v-if="isActive.table()"
                    class="formatbar__button"
                    @click="commands.deleteTable"
                >
                    <icon name="delete-table" />
                </button>
                <button
                    tabindex="-1"
                    v-if="isActive.table()"
                    class="formatbar__button"
                    @click="commands.addColumnBefore"
                >
                    <icon name="add-col-before" />
                </button>
                <button
                    tabindex="-1"
                    v-if="isActive.table()"
                    class="formatbar__button"
                    @click="commands.addColumnAfter"
                >
                    <icon name="add-col-after" />
                </button>
                <button
                    tabindex="-1"
                    v-if="isActive.table()"
                    class="formatbar__button"
                    @click="commands.deleteColumn"
                >
                    <icon name="delete-col" />
                </button>
                <button
                    tabindex="-1"
                    v-if="isActive.table()"
                    class="formatbar__button"
                    @click="commands.addRowBefore"
                >
                    <icon name="add-row-before" />
                </button>
                <button
                    tabindex="-1"
                    v-if="isActive.table()"
                    class="formatbar__button"
                    @click="commands.addRowAfter"
                >
                    <icon name="add-row-after" />
                </button>
                <button
                    tabindex="-1"
                    v-if="isActive.table()"
                    class="formatbar__button"
                    @click="commands.deleteRow"
                >
                    <icon name="delete-row" />
                </button>
                <button
                    tabindex="-1"
                    v-if="isActive.table()"
                    class="formatbar__button"
                    @click="commands.toggleCellMerge"
                >
                    <icon name="combine-cells" />
                </button>

            <button
                tabindex="-1"
                class="formatbar__button"
                @click="commands.horizontal_rule"
            >
                <icon name="hr" />
            </button>

            <button tabindex="-1" class="formatbar__button" @click="$emit('openModal', 'image')">
                <Icon name="image" />
            </button>

            <button tabindex="-1" class="formatbar__button" @click="$emit('openModal', 'video')">
                <Icon name="video" />
            </button>
        </div>
    </editor-menu-bar>
</template>

<script>
import { rgbToHex } from '@/helpers'
import { EditorMenuBar } from 'tiptap'
import VSwatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.css'

export default {
    data () {
        return {
            color: '#79797c',
            swatches: [
                { color: '#79797c', label: 'Default', showBorder: true },
                { color: '#000000', label: 'Black' },
                { color: '#D52B1E', label: 'Primary' },
                { color: '#55601C', label: 'Secondary' },
                { color: '#B0BB24', label: 'Apple' },
                { color: '#922790', label: 'Purple' },
                { color: '#0097A5', label: 'Dark Blue' },
                { color: '#76CEDF', label: 'Light Blue' },
                { color: '#FBA919', label: 'Orange' },
                { color: '#EE154B', label: 'Watermelon' }
            ],
            el: null
        }
    },

    props: {
        editor: {
            type: Object,
            required: true
        }
    },

    components: {
        EditorMenuBar,
        VSwatches
    },

    created() {
        this.el = document.querySelector('.wysiwyg__editor .ProseMirror')
        this.el.addEventListener('click', this.monitorColouredSpans)
    },

    methods: {
        setColour (color, commands) {
            if (color !== '#79797c') commands.textcolor({ style: `color: ${color}` })
            else commands.textcolor({ clear: true })
        },

        monitorColouredSpans(e) {
            const span = e.target.tagName.toLowerCase()
            if (span === 'span') this.color = rgbToHex(e.target.style.color)
            else this.color = '#79797c'

        }
    },

    beforeDestroy() {
        this.el.removeEventListener('click', this.monitorColouredSpans)
    },
}
</script>
